import { createFileRoute } from "@tanstack/react-router";
import { HubSeoContent } from "@/components/seo/HubSeoContent";
import { ParentAssessmentsIndex } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/assessments/")({
  head: () => seoHead({
    title: "Five parent assessments for kids 8-14",
    description:
      "Five short behavioural assessments answered by parents about their child. Each scores four observable skills and ends with a personalised report.",
    canonical: "/assessments",
  }),
  component: () => <><ParentAssessmentsIndex /><HubSeoContent hub="assessments" /></>,
});
